import { getFormattedDate } from '../../commons/datesUtils';

const initialState = {
  hotel: '',
  operator: '',
  locatorTTOO: '',
  operatorsList: [],
  contractsList: [],
  contractDetailList: [],
  hotelRoomsList: [],
  groupsList: []
};

function filterHotelRoomList(response) {
  if (!response) return [];

  const { roomDistributionList, hotelAgeLimitForChildren, hotelAgeLimitForBabies } = response;

  if (!roomDistributionList) return [];

  const mappedList = roomDistributionList.map((room) => {
    const {
      roomId,
      roomDescription,
      roomOccupancy,
      childrenAllowed
    } = room;

    return {
      code: roomId,
      name: `${roomId} - ${roomDescription}`,
      maxOccupancy: roomOccupancy,
      minAge: hotelAgeLimitForBabies,
      maxAge: hotelAgeLimitForChildren,
      childrenAllowed
    }
  });

  return mappedList;
}

function tourOperation(state = initialState, action = { type: ''}) {
  switch (action.type) {
    case 'SET_SELECTED_HOTEL': {
      const { hotel } = state;
      const { hotelCode } = action;

      if (hotel === hotelCode) return state;

      return {
        ...initialState,
        hotel: hotelCode
      }
    }
    case 'SET_SELECTED_OPERATOR': {
      const { operator } = state;
      const { operatorCode } = action;

      if (operator === operatorCode) return state;

      return {
        ...state,
        operator: operatorCode,
        contractsList: [],
        contractDetailList: [],
        hotelRoomsList: []
      }
    }
    case 'SET_HOTEL_ROOMS_LIST': {
      const { response } = action;

      return {
        ...state,
        hotelRoomsList: filterHotelRoomList(response)
      }
    }
    case 'SET_SELECTED_LOCATOR': {
      const { locatorCode } = action;

      return {
        ...state,
        locatorTTOO: locatorCode
      }
    }
    case 'SET_OPERATORS_LIST': {
      const { response } = action;

      const mappedList = response.map(operatorBean => ({
        label: operatorBean.name,
        value: operatorBean.id.toString()
      }));

      return {
        ...state,
        operatorsList: mappedList,
        contractsList: [],
        contractDetailList: []
      }
    }
    case 'SET_CONTRACTS_LIST': {
      const { response } = action;

      const mappedList = response.map((contractBean, index) => {
        const { rate, season, period } = contractBean;

        if (!period) return undefined;

        const { dateFrom, dateTo } = period;

        if (!dateFrom || !dateTo) return undefined;

        const formattedFromDate = getFormattedDate(dateFrom, 'YYYY-MM-DD', 'DD/MM/YYYY');
        const formattedToDate = getFormattedDate(dateTo, 'YYYY-MM-DD', 'DD/MM/YYYY');

        return {
          ...contractBean,
          id: index,
          listItem: {
            label: `${season.code}-${formattedFromDate}-${formattedToDate}-${rate.code}`,
            value: index
          }
        }
      });

      return {
        ...state,
        contractsList: mappedList.filter(x => x !== undefined),
        contractDetailList: []
      };
    }
    case 'CLEAN_CONTRACT_DETAIL_LIST': {
      return {
        ...state,
        contractDetailList: []
      }
    }
    case 'UPDATE_CONTRACT_DETAIL_LIST': {
      const { contractDetailList } = state;
      const { contract } = action;

      return {
        ...state,
        contractDetailList: [
          ...contractDetailList,
          contract
        ]
      }
    }
    case 'SET_GROUPS_LIST': {
      const { groupsList } = action;

      return {
        ...state,
        groupsList
      }
    }
    default:
      return state;
  }
}

export default tourOperation;
